// @ts-nocheck
/* eslint-disable */
import { createElement, useMemo, type ComponentType } from "react";
import { useTranslation, Trans, type TransProps } from "react-i18next";
type TypedTransProps<Value, Components> = Omit<TransProps<string>, "values" | "ns" | "i18nKey"> & ({} extends Value ? {} : {
    values: Value;
}) & {
    components: Components;
};
function createProxy(initValue: (key: string) => any) {
    function define(key: string) {
        const value = initValue(key);
        Object.defineProperty(container, key, { value, configurable: true });
        return value;
    }
    const container = {
        __proto__: new Proxy({ __proto__: null }, {
            get(_, key) {
                if (typeof key === "symbol")
                    return undefined;
                return define(key);
            }
        })
    };
    return new Proxy(container, {
        getPrototypeOf: () => null,
        setPrototypeOf: (_, v) => v === null,
        getOwnPropertyDescriptor: (_, key) => {
            if (typeof key === "symbol")
                return undefined;
            if (!(key in container))
                define(key);
            return Object.getOwnPropertyDescriptor(container, key);
        }
    });
}
export function useAFFiNEI18N(): {
    /**
      * `Confirm`
      */
    Confirm(): string;
    /**
      * `Download core data`
      */
    ["Download core data"](): string;
    /**
      * `It takes up little space on your device.`
      */
    ["It takes up little space on your device"](): string;
    /**
      * `AFFiNE Cloud`
      */
    ["AFFiNE Cloud"](): string;
    /**
      * `Members`
      */
    Members(): string;
    /**
      * `Add to favourites`
      */
    ["Add to favorites"](): string;
    /**
      * `Filter`
      */
    ["com.affine.filter"](): string;
    /**
      * `AFFiNE Cloud is upgrading now.`
      */
    ["com.affine.cloudTempDisable.title"](): string;
    /**
      * `Exported successfully`
      */
    ["com.affine.export.success.title"](): string;
    /**
      * `Please open the download folder to check.`
      */
    ["com.affine.export.success.message"](): string;
    /**
      * `Please try it again later.`
      */
    ["com.affine.export.error.message"](): string;
    /**
      * `Export failed due to an unexpected error`
      */
    ["com.affine.export.error.title"](): string;
    /**
      * `Workspace`
      */
    ["com.affine.settings.workspace"](): string;
    /**
      * `Appearance`
      */
    ["com.affine.settings.appearance"](): string;
    /**
      * `Remove Workspace`
      */
    ["com.affine.settings.workspace.remove"](): string;
    /**
      * `Remove Workspace from this device and optionally delete all data.`
      */
    ["com.affine.settings.workspace.remove.message"](): string;
    /**
      * `Noise background on the sidebar`
      */
    ["com.affine.settings.appearance.sidebar.noise"](): string;
    /**
      * `Use background noise effect on the sidebar.`
      */
    ["com.affine.settings.appearance.sidebar.noise.message"](): string;
    /**
      * `Translucent UI on the sidebar`
      */
    ["com.affine.settings.appearance.sidebar.translucent"](): string;
    /**
      * `Use transparency effect on the sidebar.`
      */
    ["com.affine.settings.appearance.sidebar.translucent.message"](): string;
    /**
      * `Automatically download updates (to this device).`
      */
    ["com.affine.settings.about.update.download.message"](): string;
    /**
      * `Automatically check for new updates periodically.`
      */
    ["com.affine.settings.about.update.check.message"](): string;
    /**
      * `Information about AFFiNE`
      */
    ["com.affine.settings.about.message"](): string;
    /**
      * `Check or change storage location`
      */
    ["com.affine.settings.storage.description"](): string;
    /**
      * `Check or change storage location. Click path to edit location.`
      */
    ["com.affine.settings.storage.description-alt"](): string;
    /**
      * `Click to move storage location.`
      */
    ["com.affine.settings.storage.db-location.change-hint"](): string;
    /**
      * `Sign in / Sign up`
      */
    ["com.affine.settings.sign"](): string;
    /**
      * `Sync with AFFiNE Cloud`
      */
    ["com.affine.setting.sign.message"](): string;
    /**
      * `Securely sign out of your account.`
      */
    ["com.affine.setting.sign.out.message"](): string;
    /**
      * `Account Settings`
      */
    ["com.affine.setting.account"](): string;
    /**
      * `Your personal information`
      */
    ["com.affine.setting.account.message"](): string;
    /**
      * `Delete Account`
      */
    ["com.affine.setting.account.delete"](): string;
    /**
      * `Permanently delete this account and the Workspace data backup in AFFiNE Cloud. This action can not be undone.`
      */
    ["com.affine.setting.account.delete.message"](): string;
    /**
      * `Email`
      */
    ["com.affine.settings.email"](): string;
    /**
      * `Change Email`
      */
    ["com.affine.settings.email.action"](): string;
    /**
      * `Password`
      */
    ["com.affine.settings.password"](): string;
    /**
      * `Set a password to sign in to your account`
      */
    ["com.affine.settings.password.message"](): string;
    /**
      * `Change password`
      */
    ["com.affine.settings.password.action.change"](): string;
    /**
      * `Set password`
      */
    ["com.affine.settings.password.action.set"](): string;
    /**
      * `My Profile`
      */
    ["com.affine.settings.profile"](): string;
    /**
      * `Your account profile will be displayed to everyone.`
      */
    ["com.affine.settings.profile.message"](): string;
    /**
      * `Display Name`
      */
    ["com.affine.settings.profile.name"](): string;
    /**
      * `Input account name`
      */
    ["com.affine.settings.profile.placeholder"](): string;
    /**
      * `Sign in`
      */
    ["com.affine.auth.sign.in"](): string;
    /**
      * `Sign up`
      */
    ["com.affine.auth.sign.up"](): string;
    /**
      * `Create your account`
      */
    ["com.affine.auth.sign.up.sent.email.subtitle"](): string;
    /**
      * `An email with a magic link has been sent to `
      */
    ["com.affine.auth.sign.sent.email.message.start"](): string;
    /**
      * ` You can click the link to create an account automatically.`
      */
    ["com.affine.auth.sign.sent.email.message.end"](): string;
    /**
      * `Your account has been created and you’re now signed in!`
      */
    ["com.affine.auth.sign.up.success.title"](): string;
    /**
      * `The app will automatically open or redirect to the web version. if you encounter any issues, you can also click the button below to  manually open the AFFiNE app.`
      */
    ["com.affine.auth.sign.up.success.subtitle"](): string;
    /**
      * `Welcome to AFFiNE Cloud, you are almost there!`
      */
    ["com.affine.auth.page.sent.email.title"](): string;
    /**
      * `Please set a password of 8-20 characters with both letters and numbers to continue signing up with `
      */
    ["com.affine.auth.page.sent.email.subtitle"](): string;
    /**
      * `Later`
      */
    ["com.affine.auth.later"](): string;
    /**
      * `Open AFFiNE`
      */
    ["com.affine.auth.open.affine"](): string;
    /**
      * `Confirm your email`
      */
    ["com.affine.auth.sign.in.sent.email.subtitle"](): string;
    /**
      * `If you haven't received the email, please check your spam folder.`
      */
    ["com.affine.auth.sign.auth.code.message"](): string;
    /**
      * `Invalid password`
      */
    ["com.affine.auth.password.error"](): string;
    /**
      * `Forgot password`
      */
    ["com.affine.auth.forget"](): string;
    /**
      * ` has signed in!`
      */
    ["com.affine.auth.has.signed"](): string;
    /**
      * `You’re almost there!`
      */
    ["com.affine.auth.signed.success.title"](): string;
    /**
      * `You have successfully signed in. The app will automatically open or redirect to the web version. if you encounter any issues, you can also click the button below to  manually open the AFFiNE app.`
      */
    ["com.affine.auth.signed.success.subtitle"](): string;
    /**
      * `Reset Password`
      */
    ["com.affine.auth.reset.password"](): string;
    /**
      * `Set password`
      */
    ["com.affine.auth.set.password"](): string;
    /**
      * `You will receive an email with a link to reset your password. Please check your inbox.`
      */
    ["com.affine.auth.reset.password.message"](): string;
    /**
      * `Send reset link`
      */
    ["com.affine.auth.send.reset.password.link"](): string;
    /**
      * `Send set link`
      */
    ["com.affine.auth.send.set.password.link"](): string;
    /**
      * `Send verification link`
      */
    ["com.affine.auth.send.change.email.link"](): string;
    /**
      * `Sent`
      */
    ["com.affine.auth.sent"](): string;
    /**
      * `Reset password link has been sent.`
      */
    ["com.affine.auth.sent.change.password.hint"](): string;
    /**
      * `Set password link has been sent.`
      */
    ["com.affine.auth.sent.set.password.hint"](): string;
    /**
      * `Verification link has been sent.`
      */
    ["com.affine.auth.sent.change.email.hint"](): string;
    /**
      * `Set your AFFiNE Cloud password`
      */
    ["com.affine.auth.set.password.page.title"](): string;
    /**
      * `Reset your AFFiNE Cloud password`
      */
    ["com.affine.auth.reset.password.page.title"](): string;
    /**
      * `Password set successful`
      */
    ["com.affine.auth.set.password.page.success"](): string;
    /**
      * `Save Password`
      */
    ["com.affine.auth.set.password.save"](): string;
    /**
      * `Save Email`
      */
    ["com.affine.auth.set.email.save"](): string;
    /**
      * `Change email address`
      */
    ["com.affine.auth.change.email.page.title"](): string;
    /**
      * `Email address updated!`
      */
    ["com.affine.auth.change.email.page.success.title"](): string;
    /**
      * `Please enter your new email address below. We will send a verification link to this email address to complete the process.`
      */
    ["com.affine.auth.change.email.page.subtitle"](): string;
    /**
      * `Congratulations! You have successfully updated the email address associated with your AFFiNE Cloud account.`
      */
    ["com.affine.auth.change.email.page.success.subtitle"](): string;
    /**
      * `Enter your email address`
      */
    ["com.affine.auth.sign.email.placeholder"](): string;
    /**
      * `Continue with Email`
      */
    ["com.affine.auth.sign.email.continue"](): string;
    /**
      * `Invalid email`
      */
    ["com.affine.auth.sign.email.error"](): string;
    /**
      * `Terms of Conditions`
      */
    ["com.affine.auth.sign.condition"](): string;
    /**
      * `Privacy Policy`
      */
    ["com.affine.auth.sign.policy"](): string;
    /**
      * `Wrong code, please try again`
      */
    ["com.affine.auth.sign.auth.code.error.hint"](): string;
    /**
      * `Send code again`
      */
    ["com.affine.auth.sign.auth.code.on.resend.hint"](): string;
    /**
      * `Resend code`
      */
    ["com.affine.auth.sign.auth.code.resend.hint"](): string;
    /**
      * `Password`
      */
    ["com.affine.auth.password"](): string;
    /**
      * `Please set a password of 8-20 characters with both letters and numbers to continue signing up with `
      */
    ["com.affine.auth.set.password.message"](): string;
    /**
      * `Set a password at least 8 letters long`
      */
    ["com.affine.auth.set.password.placeholder"](): string;
    /**
      * `Confirm password`
      */
    ["com.affine.auth.set.password.placeholder.confirm"](): string;
    /**
      * `Create Account`
      */
    ["com.affine.auth.create.count"](): string;
    /**
      * `This link has expired...`
      */
    ["com.affine.expired.page.title"](): string;
    /**
      * `Please request a new reset password link.`
      */
    ["com.affine.expired.page.subtitle"](): string;
    /**
      * `Back`
      */
    Back(): string;
    /**
      * `Page Mode`
      */
    ["com.affine.pageMode"](): string;
    /**
      * `Edgeless Mode`
      */
    ["com.affine.edgelessMode"](): string;
    /**
      * `Hyper merged whiteboard and docs`
      */
    ["com.affine.onboarding.title1"](): string;
    /**
      * `Intuitive & robust block-based editing`
      */
    ["com.affine.onboarding.title2"](): string;
    /**
      * `Easily switch between Page mode for structured document creation and Whiteboard mode for the freeform visual expression of creative ideas.`
      */
    ["com.affine.onboarding.videoDescription1"](): string;
    /**
      * `Create structured documents with ease, using a modular interface to drag and drop blocks of text, images, and other content.`
      */
    ["com.affine.onboarding.videoDescription2"](): string;
    /**
      * `Getting started`
      */
    ["com.affine.helpIsland.gettingStarted"](): string;
    /**
      * `Downloading`
      */
    ["com.affine.updater.downloading"](): string;
    /**
      * `Update available`
      */
    ["com.affine.updater.update-available"](): string;
    /**
      * `Open download page`
      */
    ["com.affine.updater.open-download-page"](): string;
    /**
      * `Restart to install update`
      */
    ["com.affine.updater.restart-to-update"](): string;
    /**
      * `Draw with a blank whiteboard`
      */
    ["com.affine.draw_with_a_blank_whiteboard"](): string;
    /**
      * `New Edgeless`
      */
    ["com.affine.new_edgeless"](): string;
    /**
      * `Write with a blank page`
      */
    ["com.affine.write_with_a_blank_page"](): string;
    /**
      * `You cannot delete the last workspace`
      */
    ["com.affine.workspace.cannot-delete"](): string;
    /**
      * `Today`
      */
    ["com.affine.today"](): string;
    /**
      * `Earlier`
      */
    ["com.affine.earlier"](): string;
    /**
      * `Yesterday`
      */
    ["com.affine.yesterday"](): string;
    /**
      * `Last month`
      */
    ["com.affine.lastMonth"](): string;
    /**
      * `Last week`
      */
    ["com.affine.lastWeek"](): string;
    /**
      * `Last year`
      */
    ["com.affine.lastYear"](): string;
    /**
      * `Support Markdown/Notion`
      */
    ["com.affine.import_file"](): string;
    /**
      * `Import`
      */
    ["com.affine.new_import"](): string;
    /**
      * `Current Year`
      */
    ["com.affine.currentYear"](): string;
    /**
      * `Last 7 Days`
      */
    ["com.affine.last7Days"](): string;
    /**
      * `Last 30 Days`
      */
    ["com.affine.last30Days"](): string;
    /**
      * `There's no page here yet`
      */
    ["com.affine.emptyDesc"](): string;
    /**
      * `after`
      */
    ["com.affine.filter.after"](): string;
    /**
      * `It takes up more space on your device.`
      */
    ["It takes up more space on your device"](): string;
    /**
      * `All changes are saved locally, click to enable AFFiNE Cloud.`
      */
    ["Saved then enable AFFiNE Cloud"](): string;
    /**
      * `Help and Feedback`
      */
    ["Help and Feedback"](): string;
    /**
      * `Export AFFiNE backup file`
      */
    ["Export AFFiNE backup file"](): string;
    /**
      * `before`
      */
    ["com.affine.filter.before"](): string;
    /**
      * `is`
      */
    ["com.affine.filter.is"](): string;
    /**
      * `is not empty`
      */
    ["com.affine.filter.is not empty"](): string;
    /**
      * `is empty`
      */
    ["com.affine.filter.is empty"](): string;
    /**
      * `contains all`
      */
    ["com.affine.filter.contains all"](): string;
    /**
      * `contains one of`
      */
    ["com.affine.filter.contains one of"](): string;
    /**
      * `does not contains all`
      */
    ["com.affine.filter.does not contains all"](): string;
    /**
      * `does not contains one of`
      */
    ["com.affine.filter.does not contains one of"](): string;
    /**
      * `true`
      */
    ["com.affine.filter.true"](): string;
    /**
      * `false`
      */
    ["com.affine.filter.false"](): string;
    /**
      * `Save View`
      */
    ["com.affine.filter.save-view"](): string;
    /**
      * `Not now`
      */
    ["Not now"](): string;
    /**
      * `You can export the entire Workspace data for backup, and the exported data can be re-imported.`
      */
    ["Export Description"](): string;
    /**
      * `Remove from workspace`
      */
    ["Remove from workspace"](): string;
    /**
      * `Please make sure you are online`
      */
    ["Please make sure you are online"](): string;
    /**
      * `Quick search`
      */
    ["Quick search"](): string;
    /**
      * `All pages`
      */
    ["All pages"](): string;
    /**
      * `No item`
      */
    ["No item"](): string;
    /**
      * `Import`
      */
    Import(): string;
    /**
      * `Trash`
      */
    Trash(): string;
    /**
      * `New Page`
      */
    ["New Page"](): string;
    /**
      * `New '{{query}}' page`
      */
    ["New Keyword Page"](options: {
        readonly query: string;
    }): string;
    /**
      * `Find 0 result`
      */
    ["Find 0 result"](): string;
    /**
      * `Find {{number}} results`
      */
    ["Find results"](options: {
        readonly number: string;
    }): string;
    /**
      * `Collapse sidebar`
      */
    ["Collapse sidebar"](): string;
    /**
      * `Expand sidebar`
      */
    ["Expand sidebar"](): string;
    /**
      * `Paper`
      */
    Paper(): string;
    /**
      * `Edgeless`
      */
    Edgeless(): string;
    /**
      * `Convert to `
      */
    ["Convert to "](): string;
    /**
      * `Page`
      */
    Page(): string;
    /**
      * `Export`
      */
    Export(): string;
    /**
      * `Export to HTML`
      */
    ["Export to HTML"](): string;
    /**
      * `Export to Markdown`
      */
    ["Export to Markdown"](): string;
    /**
      * `Delete`
      */
    Delete(): string;
    /**
      * `Title`
      */
    Title(): string;
    /**
      * `Untitled`
      */
    Untitled(): string;
    /**
      * `Tags`
      */
    Tags(): string;
    /**
      * `Created`
      */
    Created(): string;
    /**
      * `Updated`
      */
    Updated(): string;
    /**
      * `Open in new tab`
      */
    ["Open in new tab"](): string;
    /**
      * `Delete page?`
      */
    ["Delete page?"](): string;
    /**
      * `Delete permanently?`
      */
    ["Delete permanently?"](): string;
    /**
      * `{{title}} will be moved to Trash`
      */
    ["will be moved to Trash"](options: {
        readonly title: string;
    }): string;
    /**
      * `Moved to Trash`
      */
    ["Moved to Trash"](): string;
    /**
      * `Permanently deleted`
      */
    ["Permanently deleted"](): string;
    /**
      * `{{title}} restored`
      */
    restored(options: {
        readonly title: string;
    }): string;
    /**
      * `Cancel`
      */
    Cancel(): string;
    /**
      * `Official Website`
      */
    ["Official Website"](): string;
    /**
      * `Get in touch!`
      */
    ["Get in touch!"](): string;
    /**
      * `AFFiNE Community`
      */
    ["AFFiNE Community"](): string;
    /**
      * `How is AFFiNE Alpha different?`
      */
    ["How is AFFiNE Alpha different?"](): string;
    /**
      * `Shortcuts`
      */
    Shortcuts(): string;
    /**
      * `Undo`
      */
    Undo(): string;
    /**
      * `Redo`
      */
    Redo(): string;
    /**
      * `Bold`
      */
    Bold(): string;
    /**
      * `Italic`
      */
    Italic(): string;
    /**
      * `Underline`
      */
    Underline(): string;
    /**
      * `Strikethrough`
      */
    Strikethrough(): string;
    /**
      * `Inline code`
      */
    ["Inline code"](): string;
    /**
      * `Code block`
      */
    ["Code block"](): string;
    /**
      * `Body text`
      */
    ["Body text"](): string;
    /**
      * `Heading {{number}}`
      */
    Heading(options: {
        readonly number: string;
    }): string;
    /**
      * `Increase indent`
      */
    ["Increase indent"](): string;
    /**
      * `Reduce indent`
      */
    ["Reduce indent"](): string;
    /**
      * `Markdown Syntax`
      */
    ["Markdown Syntax"](): string;
    /**
      * `Divider`
      */
    Divider(): string;
    /**
      * `Once deleted, you can't undo this action.`
      */
    ["Once deleted, you can't undo this action"](): string;
    /**
      * `Contact us`
      */
    ["Contact Us"](): string;
    /**
      * `Keyboard shortcuts`
      */
    ["Keyboard Shortcuts"](): string;
    /**
      * `Add to Favourites`
      */
    ["Add to Favorites"](): string;
    /**
      * `Added to Favourites`
      */
    ["Added to Favorites"](): string;
    /**
      * `Jump to`
      */
    ["Jump to"](): string;
    /**
      * `404 - Page Not Found`
      */
    ["404 - Page Not Found"](): string;
    /**
      * `Favourite`
      */
    Favorite(): string;
    /**
      * `Favourited`
      */
    Favorited(): string;
    /**
      * `Remove from favourites`
      */
    ["Remove from favorites"](): string;
    /**
      * `Removed from Favourites`
      */
    ["Removed from Favorites"](): string;
    /**
      * `Pen`
      */
    Pen(): string;
    /**
      * `Connector`
      */
    Connector(): string;
    /**
      * `Sticky`
      */
    Sticky(): string;
    /**
      * `Text`
      */
    Text(): string;
    /**
      * `Favourited`
      */
    ["com.affine.filter.is-favourited"](): string;
    /**
      * `New Workspace`
      */
    ["New Workspace"](): string;
    /**
      * `Create`
      */
    Create(): string;
    /**
      * `Select`
      */
    Select(): string;
    /**
      * `Shape`
      */
    Shape(): string;
    /**
      * `Upload`
      */
    Upload(): string;
    /**
      * `Restore it`
      */
    ["Restore it"](): string;
    /**
      * `Permanently delete`
      */
    TrashButtonGroupTitle(): string;
    /**
      * `Once deleted, you can't undo this action. Do you confirm?`
      */
    TrashButtonGroupDescription(): string;
    /**
      * `Delete permanently`
      */
    ["Delete permanently"](): string;
    /**
      * `Hyperlink (with selected text)`
      */
    Link(): string;
    /**
      * `A workspace is your virtual space to capture, create and plan as just one person or together as a team.`
      */
    ["Workspace description"](): string;
    /**
      * `Quick Search...`
      */
    ["Quick search placeholder"](): string;
    /**
      * `Search in {{workspace}}`
      */
    ["Quick search placeholder2"](options: {
        readonly workspace: string;
    }): string;
    /**
      * `Settings`
      */
    Settings(): string;
    /**
      * `Please upgrade to the latest version of Chrome for the best experience.`
      */
    upgradeBrowser(): string;
    /**
      * `Invite Members`
      */
    ["Invite Members"](): string;
    /**
      * `Search mail (Gmail support only)`
      */
    ["Invite placeholder"](): string;
    /**
      * `Non-Gmail is not supported`
      */
    ["Non-Gmail"](): string;
    /**
      * `Invite`
      */
    Invite(): string;
    /**
      * `Loading...`
      */
    Loading(): string;
    /**
      * `Currently not logged in`
      */
    NotLoggedIn(): string;
    /**
      * `Clear local data`
      */
    ClearData(): string;
    /**
      * `Continue with Google`
      */
    ["Continue with Google"](): string;
    /**
      * `Set up an AFFiNE account to sync data`
      */
    ["Set up an AFFiNE account to sync data"](): string;
    /**
      * `Stay logged out`
      */
    ["Stay logged out"](): string;
    /**
      * `All changes are saved locally`
      */
    ["All changes are saved locally"](): string;
    /**
      * `Looks like you are browsing on a mobile device.`
      */
    ["mobile device"](): string;
    /**
      * `We are still working on mobile support and recommend you use a desktop device.`
      */
    ["mobile device description"](): string;
    /**
      * `Got it`
      */
    ["Got it"](): string;
    /**
      * `Click Add to Trash and the page will appear here.`
      */
    emptyTrash(): string;
    /**
      * `(This page is still being designed.)`
      */
    ["still designed"](): string;
    /**
      * `My Workspaces`
      */
    ["My Workspaces"](): string;
    /**
      * `Tips: `
      */
    Tips(): string;
    /**
      * `Login success`
      */
    ["login success"](): string;
    /**
      * `Create or Import`
      */
    ["Create Or Import"](): string;
    /**
      * `Delete Workspace`
      */
    ["Delete Workspace"](): string;
    /**
      * `Please type “Delete” to confirm`
      */
    ["Delete Workspace placeholder"](): string;
    /**
      * `Leave Workspace`
      */
    ["Leave Workspace"](): string;
    /**
      * `Leave`
      */
    Leave(): string;
    /**
      * `Workspace Icon`
      */
    ["Workspace Icon"](): string;
    /**
      * `Workspace Name`
      */
    ["Workspace Name"](): string;
    /**
      * `Workspace Type`
      */
    ["Workspace Type"](): string;
    /**
      * `Users`
      */
    Users(): string;
    /**
      * `Access level`
      */
    ["Access level"](): string;
    /**
      * `Pending`
      */
    Pending(): string;
    /**
      * `Collaborating with other members requires AFFiNE Cloud service.`
      */
    ["Collaboration Description"](): string;
    /**
      * `Enable AFFiNE Cloud`
      */
    ["Enable AFFiNE Cloud"](): string;
    /**
      * `If enabled, the data in this workspace will be backed up and synchronised via AFFiNE Cloud.`
      */
    ["Enable AFFiNE Cloud Description"](): string;
    /**
      * `Enable`
      */
    Enable(): string;
    /**
      * `Sign in and Enable`
      */
    ["Sign in and Enable"](): string;
    /**
      * `Skip`
      */
    Skip(): string;
    /**
      * `Publishing to web requires AFFiNE Cloud service.`
      */
    Publishing(): string;
    /**
      * `Share with link`
      */
    ["Share with link"](): string;
    /**
      * `Copy Link`
      */
    ["Copy Link"](): string;
    /**
      * `After publishing to the web, everyone can view the content of this workspace through the link.`
      */
    ["Publishing Description"](): string;
    /**
      * `Stop publishing`
      */
    ["Stop publishing"](): string;
    /**
      * `Publish to web`
      */
    ["Publish to web"](): string;
    /**
      * `General`
      */
    General(): string;
    /**
      * `Sync`
      */
    Sync(): string;
    /**
      * `Collaboration`
      */
    Collaboration(): string;
    /**
      * `Publish`
      */
    Publish(): string;
    /**
      * `Workspace Settings`
      */
    ["Workspace Settings"](): string;
    /**
      * `After you leave, you will no longer be able to access the contents of this workspace.`
      */
    ["Leave Workspace Description"](): string;
    /**
      * `{{workspaceName}} is a Local Workspace. All data is stored on the current device. You can enable AFFiNE Cloud for this workspace to keep data in sync with the cloud.`
      */
    ["Sync Description"](options: {
        readonly workspaceName: string;
    }): string;
    /**
      * `Sign in AFFiNE Cloud`
      */
    ["Sign in"](): string;
    /**
      * `Need more customisation options? You can suggest them to us in the community.`
      */
    ["Need more customization options? You can suggest them to us in the community."](): string;
    /**
      * `Organise pages to build knowledge`
      */
    ["Organize pages to build knowledge"](): string;
    /**
      * `core`
      */
    core(): string;
    /**
      * `all`
      */
    all(): string;
    /**
      * `Data sync mode`
      */
    ["Data sync mode"](): string;
    /**
      * `Check Our Docs`
      */
    ["Check Our Docs"](): string;
    /**
      * `Get in touch! Join our communities.`
      */
    ["Get in touch! Join our communities"](): string;
    /**
      * `Favourites`
      */
    Favorites(): string;
    /**
      * `Download {{CoreOrAll}} data`
      */
    ["Download data"](options: {
        readonly CoreOrAll: string;
    }): string;
    /**
      * `Back Home`
      */
    ["Back Home"](): string;
    /**
      * `Set a Workspace name`
      */
    ["Set a Workspace name"](): string;
    /**
      * `Retain local cached data`
      */
    ["Retain local cached data"](): string;
    /**
      * `Wait for Sync`
      */
    ["Wait for Sync"](): string;
    /**
      * `Force Sign Out`
      */
    ["Force Sign Out"](): string;
    /**
      * `Local Workspace`
      */
    ["Local Workspace"](): string;
    /**
      * `Cloud Workspace`
      */
    ["Cloud Workspace"](): string;
    /**
      * `Joined Workspace`
      */
    ["Joined Workspace"](): string;
    /**
      * `Available Offline`
      */
    ["Available Offline"](): string;
    /**
      * `Published to Web`
      */
    ["Published to Web"](): string;
    /**
      * `Workspace Avatar`
      */
    ["Workspace Avatar"](): string;
    /**
      * `Owner`
      */
    Owner(): string;
    /**
      * `Member`
      */
    Member(): string;
    /**
      * `Delete Member?`
      */
    ["Delete Member?"](): string;
    /**
      * `will delete member`
      */
    ["will delete member"](): string;
    /**
      * `{{name}} has been removed`
      */
    ["Member has been removed"](options: {
        readonly name: string;
    }): string;
    /**
      * `Failed to publish workspace`
      */
    ["Failed to publish workspace"](): string;
    /**
      * `Copied link to clipboard`
      */
    ["Copied link to clipboard"](): string;
    /**
      * ` The current workspace has been published to the web, everyone can view the contents of this workspace through the link.`
      */
    ["Published Description"](): string;
    /**
      * `is a Local Workspace.`
      */
    ["is a Local Workspace"](): string;
    /**
      * `is a Cloud Workspace.`
      */
    ["is a Cloud Workspace"](): string;
    /**
      * `All data is stored on the current device. You can enable AFFiNE Cloud for this workspace to keep data in sync with the cloud.`
      */
    ["Local Workspace Description"](): string;
    /**
      * `It takes up more space on your device.`
      */
    ["Download data Description1"](): string;
    /**
      * `It takes up little space on your device.`
      */
    ["Download data Description2"](): string;
    /**
      * `Enabled success`
      */
    ["Enabled success"](): string;
    /**
      * `Sign out`
      */
    ["Sign out"](): string;
    /**
      * `All data has been stored in the cloud. `
      */
    ["All data has been stored in the cloud"](): string;
    /**
      * `Download all data`
      */
    ["Download all data"](): string;
    /**
      * `Edit`
      */
    Edit(): string;
    /**
      * `Signing out will cause the unsynchronised content to be lost.`
      */
    ["Sign out description"](): string;
    /**
      * `Retain cached cloud data`
      */
    ["Retain cached cloud data"](): string;
    /**
      * `Workspace Owner`
      */
    ["Workspace Owner"](): string;
    /**
      * `Click Add to Favourites and the page will appear here.`
      */
    emptyFavorite(): string;
    /**
      * `Move to Trash`
      */
    ["Move to Trash"](): string;
    /**
      * `Please type workspace name to confirm`
      */
    ["Placeholder of delete workspace"](): string;
    /**
      * `Pivots`
      */
    Pivots(): string;
    /**
      * `Add a subpage inside`
      */
    ["Add a subpage inside"](): string;
    /**
      * `Move to`
      */
    ["Move to"](): string;
    /**
      * `Rename`
      */
    Rename(): string;
    /**
      * `Pages can be freely added/removed from pivots, remaining accessible from "All Pages".`
      */
    RFP(): string;
    /**
      * `Remove from Pivots`
      */
    ["Remove from Pivots"](): string;
    /**
      * `Move page to...`
      */
    ["Move page to"](): string;
    /**
      * `Discover what's new!`
      */
    ["Discover what's new!"](): string;
    /**
      * `View Navigation Path`
      */
    ["View Navigation Path"](): string;
    /**
      * `Back to Quick Search`
      */
    ["Back to Quick Search"](): string;
    /**
      * `Navigation Path`
      */
    ["Navigation Path"](): string;
    /**
      * `Open Workspace Settings`
      */
    ["Open Workspace Settings"](): string;
    /**
      * `Sharing page publicly requires AFFiNE Cloud service.`
      */
    ["Shared Pages Description"](): string;
    /**
      * `Shared Pages`
      */
    ["Shared Pages"](): string;
    /**
      * `Disable Public Sharing`
      */
    ["Disable Public Sharing"](): string;
    /**
      * `Disable Public Link ?`
      */
    ["Disable Public Link ?"](): string;
    /**
      * `Disabling this public link will prevent anyone with the link from accessing this page.`
      */
    ["Disable Public Link Description"](): string;
    /**
      * `Disable`
      */
    Disable(): string;
    /**
      * `Download a static copy of your page to share with others.`
      */
    ["Export Shared Pages Description"](): string;
    /**
      * `Disable Public Link`
      */
    ["Disable Public Link"](): string;
    /**
      * `Invite others to join the Workspace or publish it to web.`
      */
    ["Share Menu Public Workspace Description1"](): string;
    /**
      * `Current workspace has been published to the web as a public workspace.`
      */
    ["Share Menu Public Workspace Description2"](): string;
    /**
      * `Create a link you can easily share with anyone.`
      */
    ["Create Shared Link Description"](): string;
    /**
      * `Loading All Workspaces`
      */
    ["Loading All Workspaces"](): string;
    /**
      * `Router is Loading`
      */
    ["Router is Loading"](): string;
    /**
      * `Finding Workspace ID`
      */
    ["Finding Workspace ID"](): string;
    /**
      * `Finding Current Workspace`
      */
    ["Finding Current Workspace"](): string;
    /**
      * `Workspace Not Found`
      */
    ["Workspace Not Found"](): string;
    /**
      * `Page is Loading`
      */
    ["Page is Loading"](): string;
    /**
      * `Loading Page`
      */
    ["Loading Page"](): string;
    /**
      * `Favourite pages for easy access`
      */
    ["Favorite pages for easy access"](): string;
    /**
      * `Shared pages will appear here.`
      */
    emptySharedPages(): string;
    /**
      * `You cannot delete the last workspace`
      */
    ["You cannot delete the last workspace"](): string;
    /**
      * `Synced with AFFiNE Cloud`
      */
    ["Synced with AFFiNE Cloud"](): string;
    /**
      * `Recent`
      */
    Recent(): string;
    /**
      * `Successfully deleted`
      */
    ["Successfully deleted"](): string;
    /**
      * `Restart to install update`
      */
    ["Restart Install Client Update"](): string;
    /**
      * `Add Workspace`
      */
    ["Add Workspace"](): string;
    /**
      * `Export success`
      */
    ["Export success"](): string;
    /**
      * `Sync across devices with AFFiNE Cloud`
      */
    ["Sync across devices with AFFiNE Cloud"](): string;
    /**
      * `Update workspace name success`
      */
    ["Update workspace name success"](): string;
    /**
      * `Create your own workspace`
      */
    ["Create your own workspace"](): string;
    /**
      * `Save`
      */
    Save(): string;
    /**
      * `Move folder success`
      */
    ["Move folder success"](): string;
    /**
      * `Use on current device only`
      */
    ["Use on current device only"](): string;
    /**
      * `Check the where the storage folder is located.`
      */
    ["Open folder hint"](): string;
    /**
      * `Select the existed database file`
      */
    ["Add Workspace Hint"](): string;
    /**
      * `Customise`
      */
    Customize(): string;
    /**
      * `Created Successfully`
      */
    ["Created Successfully"](): string;
    /**
      * `Continue`
      */
    Continue(): string;
    /**
      * `Select where you want to create your workspace. The data of workspace is saved locally by default.`
      */
    ["Workspace database storage description"](): string;
    /**
      * `Added Successfully`
      */
    ["Added Successfully"](): string;
    /**
      * `Database file already loaded`
      */
    DB_FILE_ALREADY_LOADED(): string;
    /**
      * `Unknown error`
      */
    UNKNOWN_ERROR(): string;
    /**
      * `Default Location`
      */
    ["Default Location"](): string;
    /**
      * `Open`
      */
    ["Open folder"](): string;
    /**
      * `Move`
      */
    ["Move folder"](): string;
    /**
      * `Set database location`
      */
    ["Set database location"](): string;
    /**
      * `Select a new storage location.`
      */
    ["Move folder hint"](): string;
    /**
      * `Storage Folder`
      */
    ["Storage Folder"](): string;
    /**
      * `Invalid Database file`
      */
    DB_FILE_INVALID(): string;
    /**
      * `Database file migration failed`
      */
    DB_FILE_MIGRATION_FAILED(): string;
    /**
      * `Name Your Workspace`
      */
    ["Name Your Workspace"](): string;
    /**
      * `New avatar will be shown for everyone.`
      */
    ["Change avatar hint"](): string;
    /**
      * `New name will be shown for everyone.`
      */
    ["Change workspace name hint"](): string;
    /**
      * `After deleting this Workspace, you will permanently delete all of its content for everyone. No one will be able to recover the content of this Workspace.`
      */
    ["Delete Workspace Label Hint"](): string;
    /**
      * `Database file path invalid`
      */
    DB_FILE_PATH_INVALID(): string;
    /**
      * `By default will be saved to {{location}}`
      */
    ["Default db location hint"](options: {
        readonly location: string;
    }): string;
    /**
      * `File already exists`
      */
    FILE_ALREADY_EXISTS(): string;
    /**
      * `Others`
      */
    others(): string;
    /**
      * `Update available`
      */
    ["Update Available"](): string;
    /**
      * `Dark`
      */
    dark(): string;
    /**
      * `System`
      */
    system(): string;
    /**
      * `Light`
      */
    light(): string;
    /**
      * `Export to PDF`
      */
    ["Export to PDF"](): string;
    /**
      * `Export to PNG`
      */
    ["Export to PNG"](): string;
    /**
      * `Created with`
      */
    ["Created with"](): string;
    /**
      * `By default, the week starts on Sunday.`
      */
    ["By default, the week starts on Sunday."](): string;
    /**
      * `View the AFFiNE Changelog.`
      */
    ["View the AFFiNE Changelog."](): string;
    /**
      * `Elbowed Connector`
      */
    ["Elbowed Connector"](): string;
    /**
      * `About AFFiNE`
      */
    ["About AFFiNE"](): string;
    /**
      * `Zoom in`
      */
    ["Zoom in"](): string;
    /**
      * `Maximum display of content within a page.`
      */
    ["Maximum display of content within a page."](): string;
    /**
      * `None yet`
      */
    ["None yet"](): string;
    /**
      * `Quick Search`
      */
    ["Quick Search"](): string;
    /**
      * `Theme`
      */
    Theme(): string;
    /**
      * `Image`
      */
    Image(): string;
    /**
      * `Customise the appearance of the client.`
      */
    ["Customize the appearance of the client."](): string;
    /**
      * `Zoom to fit`
      */
    ["Zoom to fit"](): string;
    /**
      * `Straight Connector`
      */
    ["Straight Connector"](): string;
    /**
      * `Client Border Style`
      */
    ["Client Border Style"](): string;
    /**
      * `Appearance Settings`
      */
    ["Appearance Settings"](): string;
    /**
      * `Zoom out`
      */
    ["Zoom out"](): string;
    /**
      * `Group as Database`
      */
    ["Group as Database"](): string;
    /**
      * `Check Keyboard Shortcuts quickly`
      */
    ["Check Keyboard Shortcuts quickly"](): string;
    /**
      * `Customise appearance of Windows Client.`
      */
    ["Customize appearance of Windows Client."](): string;
    /**
      * `Append to Daily Note`
      */
    ["Append to Daily Note"](): string;
    /**
      * `Start Week On Monday`
      */
    ["Start Week On Monday"](): string;
    /**
      * `Move Down`
      */
    ["Move Down"](): string;
    /**
      * `Ungroup`
      */
    Ungroup(): string;
    /**
      * `Version`
      */
    Version(): string;
    /**
      * `App Version`
      */
    ["App Version"](): string;
    /**
      * `Editor Version`
      */
    ["Editor Version"](): string;
    /**
      * `Frameless`
      */
    frameless(): string;
    /**
      * `Check for updates automatically`
      */
    ["Check for updates automatically"](): string;
    /**
      * `Note`
      */
    Note(): string;
    /**
      * `Zoom to 100%`
      */
    ["Zoom to 100%"](): string;
    /**
      * `Hand`
      */
    Hand(): string;
    /**
      * `Group`
      */
    Group(): string;
    /**
      * `Communities`
      */
    Communities(): string;
    /**
      * `Date Format`
      */
    ["Date Format"](): string;
    /**
      * `Select All`
      */
    ["Select All"](): string;
    /**
      * `Collections`
      */
    Collections(): string;
    /**
      * `Save As New Collection`
      */
    ["Save As New Collection"](): string;
    /**
      * `Update Collection`
      */
    ["Update Collection"](): string;
    /**
      * `Pin to Sidebar`
      */
    ["com.affine.collection-bar.action.tooltip.pin"](): string;
    /**
      * `Unpin`
      */
    ["com.affine.collection-bar.action.tooltip.unpin"](): string;
    /**
      * `Edit`
      */
    ["com.affine.collection-bar.action.tooltip.edit"](): string;
    /**
      * `Delete`
      */
    ["com.affine.collection-bar.action.tooltip.delete"](): string;
    /**
      * `Back to all`
      */
    ["Back to all"](): string;
    /**
      * `Edit Filter`
      */
    ["Edit Filter"](): string;
    /**
      * `Unpin`
      */
    Unpin(): string;
    /**
      * `Remove special filter`
      */
    ["Remove special filter"](): string;
    /**
      * `Exclude from filter`
      */
    ["Exclude from filter"](): string;
    /**
      * `Customise your date style.`
      */
    ["Customize your date style."](): string;
    /**
      * `Contact Us`
      */
    ["Contact with us"](): string;
    /**
      * `Terms of Use`
      */
    ["Terms of Use"](): string;
    /**
      * `Go Back`
      */
    ["Go Back"](): string;
    /**
      * `Download updates automatically`
      */
    ["Download updates automatically"](): string;
    /**
      * `Privacy`
      */
    Privacy(): string;
    /**
      * `Go Forward`
      */
    ["Go Forward"](): string;
    /**
      * `Expand/Collapse Sidebar`
      */
    ["Expand/Collapse Sidebar"](): string;
    /**
      * `Select the language for the interface.`
      */
    ["Select the language for the interface."](): string;
    /**
      * `Native Titlebar`
      */
    NativeTitleBar(): string;
    /**
      * `Sidebar`
      */
    Sidebar(): string;
    /**
      * `Display Language`
      */
    ["Display Language"](): string;
    /**
      * `Discover what's new`
      */
    ["Discover what's new"](): string;
    /**
      * `New version is ready`
      */
    ["New version is ready"](): string;
    /**
      * `Noise background on the sidebar`
      */
    ["Noise background on the sidebar"](): string;
    /**
      * `Translucent UI on the sidebar`
      */
    ["Translucent UI on the sidebar"](): string;
    /**
      * `Window frame style`
      */
    ["Window frame style"](): string;
    /**
      * `Move Up`
      */
    ["Move Up"](): string;
    /**
      * `Curve Connector`
      */
    ["Curve Connector"](): string;
    /**
      * `Check for updates`
      */
    ["Check for updates"](): string;
    /**
      * `Full width Layout`
      */
    ["Full width Layout"](): string;
    /**
      * `Date`
      */
    Date(): string;
    /**
      * `If enabled, it will automatically check for new versions at regular intervals.`
      */
    ["If enabled, it will automatically check for new versions at regular intervals."](): string;
    /**
      * ` If enabled, new versions will be automatically downloaded to the current device.`
      */
    ["If enabled, new versions will be automatically downloaded to the current device."](): string;
    /**
      * `Choose your colour scheme`
      */
    ["Choose your color scheme"](): string;
    /**
      * `Colour Scheme`
      */
    ["Color Scheme"](): string;
    /**
      * `Customise your  AFFiNE Appearance`
      */
    ["Customize your  AFFiNE Appearance"](): string;
    /**
      * `Legal Info`
      */
    ["Info of legal"](): string;
    /**
      * `Copy`
      */
    Copy(): string;
    /**
      * `The following functions rely on AFFiNE Cloud. All data is stored on the current device. You can enable AFFiNE Cloud for this workspace to keep data in sync with the cloud.`
      */
    ["Enable cloud hint"](): string;
    /**
      * `Storage and Export`
      */
    ["Storage and Export"](): string;
    /**
      * `Info`
      */
    Info(): string;
    /**
      * `Only an owner can edit the the Workspace avatar and name.Changes will be shown for everyone.`
      */
    ["Only an owner can edit the the Workspace avatar and name.Changes will be shown for everyone."](): string;
    /**
      * `{{name}} is saved locally`
      */
    ["Workspace saved locally"](options: {
        readonly name: string;
    }): string;
    /**
      * `Workspace Profile`
      */
    ["Workspace Profile"](): string;
    /**
      * `Storage`
      */
    Storage(): string;
    /**
      * `Visitors can view the contents through the provided link.`
      */
    ["Published hint"](): string;
    /**
      * `Once published to the web, visitors can view the contents through the provided link.`
      */
    ["Unpublished hint"](): string;
    /**
      * `Manage members here, invite new member by email.`
      */
    ["Members hint"](): string;
    /**
      * `{{name}}'s Settings`
      */
    ["Workspace Settings with name"](options: {
        readonly name: string;
    }): string;
    /**
      * `You can customise your workspace here.`
      */
    ["You can customize your workspace here."](): string;
    /**
      * `Font Style`
      */
    ["Font Style"](): string;
    /**
      * `Choose your font style`
      */
    ["Choose your font style"](): string;
    /**
      * `Switch`
      */
    Switch(): string;
    /**
      * `Enable AFFiNE Cloud to publish this Workspace`
      */
    ["com.affine.settings.workspace.publish.local-tooltip"](): string;
    /**
      * `Enable AFFiNE Cloud to collaborate with others`
      */
    ["com.affine.settings.workspace.member.local-tooltip"](): string;
    /**
      * `Add Tag`
      */
    ["com.affine.header.option.add-tag"](): string;
    /**
      * `Duplicate`
      */
    ["com.affine.header.option.duplicate"](): string;
} { const { t } = useTranslation(); return useMemo(() => createProxy((key) => t.bind(null, key)), [t]); }
function createComponent(i18nKey: string) {
    return (props) => createElement(Trans, { i18nKey, shouldUnescape: true, ...props });
}
export const TypedTrans: {
    /**
      * `We are upgrading the AFFiNE Cloud service and it is temporarily unavailable on the client side. If you wish to stay updated on the progress and be notified on availability, you can fill out the <1>AFFiNE Cloud Signup</1>.`
      */
    ["com.affine.cloudTempDisable.description"]: ComponentType<TypedTransProps<Readonly<{}>, {
        ["1"]: JSX.Element;
    }>>;
    /**
      * `If you haven't received the email, please check your spam folder. Or <1>sign in with password</1> instead.`
      */
    ["com.affine.auth.sign.auth.code.message.password"]: ComponentType<TypedTransProps<Readonly<{}>, {
        ["1"]: JSX.Element;
    }>>;
    /**
      * `By clicking “Continue with Google/Email” above, you acknowledge that you agree to AFFiNE's <1>Terms of Conditions</1> and <3>Privacy Policy</3>.`
      */
    ["com.affine.auth.sign.message"]: ComponentType<TypedTransProps<Readonly<{}>, {
        ["1"]: JSX.Element;
        ["3"]: JSX.Element;
    }>>;
    /**
      * `This demo is limited. <1>Download the AFFiNE Client</1> for the latest features and Performance.`
      */
    ["com.affine.banner.content"]: ComponentType<TypedTransProps<Readonly<{}>, {
        ["1"]: JSX.Element;
    }>>;
    /**
      * `Click on the <1>$t(New Page)</1> button to create your first page.`
      */
    emptyAllPages: ComponentType<TypedTransProps<Readonly<{}>, {
        ["1"]: JSX.Element;
    }>>;
    /**
      * ` We recommend the <1>Chrome</1> browser for optimal experience.`
      */
    recommendBrowser: ComponentType<TypedTransProps<Readonly<{}>, {
        ["1"]: JSX.Element;
    }>>;
    /**
      * `Export Workspace <1>{{workspace}}</1> is coming soon`
      */
    ["Export Workspace"]: ComponentType<TypedTransProps<{
        readonly workspace: string;
    }, {
        ["1"]: JSX.Element;
    }>>;
    /**
      * `<1>{{workspaceName}}</1> is a Cloud Workspace. All data will be synchronised and saved to AFFiNE Cloud.`
      */
    ["Sync Description2"]: ComponentType<TypedTransProps<{
        readonly workspaceName: string;
    }, {
        ["1"]: JSX.Element;
    }>>;
    /**
      * `Deleting <1>{{workspace}}</1> cannot be undone, please proceed with caution. All contents will be lost.`
      */
    ["Delete Workspace Description"]: ComponentType<TypedTransProps<{
        readonly workspace: string;
    }, {
        ["1"]: JSX.Element;
    }>>;
    /**
      * `Deleting <1>{{workspace}}</1> will delete both local and cloud data, this operation cannot be undone, please proceed with caution.`
      */
    ["Delete Workspace Description2"]: ComponentType<TypedTransProps<{
        readonly workspace: string;
    }, {
        ["1"]: JSX.Element;
    }>>;
    /**
      * `All data will be synchronised and saved to the AFFiNE account <1>{{email}}</1>`
      */
    ["Cloud Workspace Description"]: ComponentType<TypedTransProps<{
        readonly email: string;
    }, {
        ["1"]: JSX.Element;
    }>>;
    /**
      * `The entire Workspace is published on the web and can be edited via <1>Workspace Settings</1>.`
      */
    ["Shared Pages In Public Workspace Description"]: ComponentType<TypedTransProps<Readonly<{}>, {
        ["1"]: JSX.Element;
    }>>;
    /**
      * `Click on the <1>$t(New Page)</1> button Or press <3>{{shortcut}}</3> to create your first page.`
      */
    emptyAllPagesClient: ComponentType<TypedTransProps<{
        readonly shortcut: string;
    }, {
        ["1"]: JSX.Element;
        ["3"]: JSX.Element;
    }>>;
} = /*#__PURE__*/ createProxy(createComponent);
